<template>
  <overlay-template
    :title="'Day rate'"
    :primary-number="rate.dayRate"
    :primary-number-unit="'/person'"
    :primary-number-title="'Minimum'"
    :secondary-number="rate.dayBreakEven"
    :good-for="[
      'Scoping the length of each task (0.25 days, 0.5 days, 1 day)',
      'Scoping very short projects',
      'Bug fixing and testing'
    ]"
    :not-good-for="[
      'Estimating the length of a project',
      'Estimating the complexity of a project',
      'Resourcing',
      'Scheduling a project',
      'Tracking revenue',
      'Forecasting'
    ]"
  >
    <div slot="intro">
      <p>Your day rate is the amount you charge for one day of work.</p>
      <p>Your day rate is the smallest unit of time we recommend for detailed estimating. While it&rsquo;s almost impossible to estimate how many hours it takes to complete a task, you can estimate fairly accurately when applying days as the primary unit (quarter and half-days are acceptable). </p>
      <p>Because days are a task-level estimating unit, we don&rsquo;t need to account for capacity like we do for month, sprint, and week rates.</p>
    </div>
    <p slot="formula">{{ rate.goal.incoming | currency }} total annual revenue &divide; {{ rate.goal.billableEmployees }} billable employees &divide; {{ rate.goal.workingWeeks }} average working weeks &divide; 5 days = <strong>{{ rate.dayRate | currency }}/day/person</strong></p>
    <p slot="break-even-formula">{{ rate.goal.outgoing | currency }} total annual expenses &divide; {{ rate.goal.billableEmployees }} billable employees &divide; {{ rate.goal.workingWeeks }} average working weeks &divide; 5 days = <strong>{{ rate.dayBreakEven | currency }}/day/person</strong></p>
    <div
      v-if="rate.dayRate"
      slot="charts"
      class="grid-column-span-3 grid-column-span-2_lg">
      <div class="reverse p2 c1 group">
        <h2>Ballpark task estimator</h2>
        <p class="measure left">Calculate a high-level estimate for your task, meeting, or small project based on people needed and duration.</p>
        <p class="mb2 align-right"><span class="font-size-8 extra-condensed price">{{ days * people * rate.dayRate | currency }}</span> <span
          v-if="rate.dayBreakEven"
          class="font-size-2 bold dark-red-300-text mb0">{{ days * people * rate.dayBreakEven | currency }}</span>&nbsp;<span class="font-size-1 dark-red-300-text m0 semibold">break even</span></p>
        <lw-range-input
          :label="days + ' day task'"
          :min="0.25"
          :max="20"
          :step="0.25"
          :class="'clear mb2'"
          v-model="days"
        />
        <lw-range-input
          :label="peopleLabel"
          :min="1"
          :max="rate.goal.billableEmployees"
          :step="1"
          v-model="people"
        />
      </div>
    </div>
  </overlay-template>
</template>

<script>
import OverlayTemplate from './OverlayTemplate.vue'
import RangeInput from '../../livewires/RangeInput.vue'

export default {
  components: {
    overlayTemplate: OverlayTemplate,
    lwRangeInput: RangeInput
  },
  data () {
    return {
      page: this.$route.params.id,
      people: 1,
      days: 0.25
    }
  },
  computed: {
    rate () {
      return this.$store.getters.rateCard(this.page)
    },
    peopleLabel () {
      const label = this.people > 1 ? 'Multiplied by ' + this.people + ' people' : 'For ' + this.people + ' person'
      return label
    }
  }
}
</script>
